module.exports = __webpack_public_path__ + "static/media/arrowLeft.37744431.svg";